export { default } from "./src/template-modal-button";
export type { UniformTemplateModalButtonProps } from "./src/template-modal-button";
